enum RecurringIntervalType {
  MONTHLY = "1 month",
  WEEKLY = "1 week",
  DAILY = "1 day",
  CUSTOM = "CUSTOM",
  NEVER = "NEVER",
}

export default RecurringIntervalType;
